import { useLayoutEffect, useState } from 'react';

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useLayoutEffect(() => {
    function handleResize() {
      // Mobile es ESTRICTAMENTE < 768px. A 768px exactos el CSS ya aplica `md:`
      // (Tablet/Desktop), así que el JS debe coincidir: 768px = NO mobile. Usar <=
      // dejaba 768px como Mobile en JS mientras el CSS lo trataba como Tablet, lo que
      // ocultaba el BookingSection inline (condiciones !isMobile) y la composición Desktop.
      if (window.innerWidth < 768) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    }
    // Set the initial state
    handleResize();
    // Add the event listener
    window.addEventListener('resize', handleResize);
    // Remove the event listener on cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isMobile;
};

export default useIsMobile;
